// extracted by mini-css-extract-plugin
export var container = "_1v-0";
export var disabled = "_1v-4";
export var fullWidth = "_1v-3";
export var lined = "_1v-1";
export var selected = "_1v-5";
export var tab = "_1v-2";